import { USER_ERRORS } from "../user/user-errors.js";

export const AUTH_ERROR_CODES = {
	OAUTH_ACCOUNT: "oauth_account",
	EMAIL_ACCOUNT: "email_account",
	RESEND_COOLDOWN: "resend_cooldown",
	INVALID_CODE: "invalid_code",
	CODE_EXPIRED: "expired",
	MAX_ATTEMPTS: "max_attempts",
	INVALID_GOOGLE_TOKEN: "invalid_google_token",
	INVALID_MICROSOFT_TOKEN: "invalid_microsoft_token",
	MICROSOFT_EMAIL_UNAVAILABLE: "microsoft_email_unavailable",
	NO_REFRESH_TOKEN: "no_refresh_token",
	INVALID_REFRESH_TOKEN: "invalid_refresh_token",
	USER_NOT_FOUND: USER_ERRORS.NOT_FOUND,
	INVALID_EXCHANGE_CODE: "invalid_exchange_code",
	EXCHANGE_CODE_EXPIRED: "exchange_code_expired",
	EMAIL_ALREADY_IN_USE: "email_already_in_use",
	SAME_EMAIL: "same_email",
} as const;

export type AuthErrorCode = (typeof AUTH_ERROR_CODES)[keyof typeof AUTH_ERROR_CODES];

export type AuthMethodErrorType = typeof AUTH_ERROR_CODES.OAUTH_ACCOUNT | typeof AUTH_ERROR_CODES.EMAIL_ACCOUNT;

export interface ApiErrorResponse {
	error?: string;
	provider?: string;
}

export function isApiError(err: unknown): err is { data: ApiErrorResponse } {
	if (typeof err !== "object" || err === null || !("data" in err)) return false;
	const data = (err as Record<string, unknown>).data;
	return typeof data === "object" && data !== null && "error" in data && typeof (data as Record<string, unknown>).error === "string";
}
